module.exports = __webpack_public_path__ + "media/images/icons/filters-264f89ee751e4de7b3c4fb727a25b73c.svg";